module.exports = __webpack_public_path__ + "img/step3_img.357180f5.png";